import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
    .module('bringoz.admin.addresses')
    .service('addressesAPI', AddressesAPI);

function AddressesAPI(): BringozApi {
    return {
        base: `/addresses`,
        infiniteScroll: {
            address: `/addresses`,
            cmd: 'GET'
        },
        actions: {
            getAddresses: {
                address: '',
                cmd: 'GET',
                updateable: false
            },
            getAddress: {
                address: '',
                cmd: 'GET',
                updateable: false
            },
            createAddress: {
                address: '',
                cmd: 'PUT',
                updateable: false
            },
            updateAddress: {
                address: '',
                cmd: 'POST',
                updateable: false
            },
            deleteAddress: {
                address: '',
                cmd: 'DELETE',
                updateable: false
            },
            getOrdersAndServices: {
                address: 'associatedServicesOms/{addressid}',
                cmd: 'GET',
                updateable: false
            },
            validatedAddress: {
                address: 'validateAddress',
                cmd: 'POST',
                updateable: false
            },
        }
    }
}
